import React from 'react';
import styled from 'styled-components';
import { breakpoints } from '../../constants/styles';
import { space, layout } from 'styled-system';

const StyledResultImage = styled.img`
  align-self: flex-end;
  max-width: 220px;
  height: auto;
  align-self: center;
  margin-bottom: 20px;
  ${breakpoints.tabletLandscape} {
    margin-top: 80px;
  }
  ${space}
  ${layout}
`;

export default function ResultImage({ tool, ...rest }) {
  return (
    <StyledResultImage
      {...rest}
      src={`https://s3.us-east-2.amazonaws.com/finauta/tools/${tool}.jpg`}
    />
  );
}
